import React from "react";
import { Typography, Box } from "@mui/material";
import companyLogo from "../../../assets/images/companyLogo.svg";

function Policy(props) {
  const { policyData } = props;
  return (
    <div className="customerPolicyLayout">
      {/* Header section with logo and title */}
      <Box sx={{ display: "flex", alignItems: "center"}}>
        <img 
          src={companyLogo} 
          alt="Company Logo" 
          style={{ height: "100px", width: "120px", marginLeft: "-16px" }}
        />
        <Typography variant="h5" sx={{ color: "#0f538d", fontWeight: 450}}>
          Your Agreement with <span style={{ fontWeight: 600 }}>ITER Mobility</span>
        </Typography>
      </Box>
      <Typography sx={{ fontSize: "14px", color: "#666666", marginBottom: "24px" }}>
        Last updated: 14/01/2026
      </Typography>
      <Box sx={{ borderBottom: "2px dashed #cccccc", marginBottom: "32px" }} />
      
      {policyData &&
        policyData.map((policy, index) => (
          <div key={index} className="policyContentSection">
            {" "}
            {policy.title && policy.body ? (
              <div>
                <Typography className="policyTitle">
                  {index + 1}. {policy.title}
                </Typography>
                <div>
                  {policy.body.length > 1 ? (
                    policy.body.map((p, idx) => (
                      <div key={idx}>
                        <Typography className="policyTitle">
                          {index + 1}.{idx + 1} {p?.subTitle}
                        </Typography>
                        <ul type="disc">
                          <li className="policyDescription">{p?.content[0]}</li>
                          <li className="policyDescription">{p?.content[1]}</li>
                          {/* <li>{p?.content[2]}</li> */}
                        </ul>
                      </div>
                    ))
                  ) : (
                    <div key={index}>
                      <Typography className="policyTitle">
                        {index + 1}.{index}. {policy.body[0]?.subTitle}
                      </Typography>
                      <ul type="disc">
                        <li className="policyDescription">{policy.body[0]?.content[0]}</li>
                        <li className="policyDescription">{policy.body[0]?.content[1]}</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ) : policy.body && policy.content ? (
              <div key={index}>
                <Typography className="policyDescription">
                  {" "}
                  {policy.body}
                </Typography>
                <div>
                  {policy.content.length > 1 &&
                    policy.content.map((p, idx) => (
                      <div className="marginTop" key={idx}>
                        <Typography className="policyTitle">
                          {idx + 1}. {p?.title}
                        </Typography>
                        <Typography className="policyDescription">{p?.description}</Typography>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <ol type={index} start={index + 1}>
                <li key={index}>
                  <span className="policyTitle"> {policy.title} : </span>
                  <span className="policyDescription">{policy.content}</span>
                </li>
              </ol>
            )}
          </div>
        ))}
    </div>
  );
}

export default Policy;
